import React, { useEffect, useState, useCallback, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBtn,
} from 'mdb-react-ui-kit'
import ActivityStore from '../../shared/stores/activity.store'

import './VideoPlayerModal.scss'

const VideoPlayerModal = props => {
  let debounceTimer = useRef(null)
  const [dimensions, setDimensions] = useState({ height: '90%', width: '90%' })

  const close = () => {
    // Resume inactivity timer when video is closed
    ActivityStore.resumeTimer()
    if (typeof props?.onClose === 'function') props.onClose()
  }

  const setModalDimensions = useCallback(() => {
    let height = window?.innerHeight - 150,
      width = window?.innerWidth - 100
    if (width > (height * 16) / 9) {
      width = (height * 16) / 9
    } else {
      height = (width * 9) / 16
    }
    setDimensions({ height, width })
  }, [])

  const windowResizeHandler = useCallback(() => {
    if (debounceTimer) window.clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      setModalDimensions()
      if (debounceTimer) window.clearTimeout(debounceTimer)
    }, 250)
  }, [])

  const unbind = useCallback(() => {
    window.removeEventListener('resize', windowResizeHandler, false)
  }, [windowResizeHandler])

  const bind = useCallback(() => {
    unbind()
    window.addEventListener('resize', windowResizeHandler, false)
  }, [unbind, windowResizeHandler])

  useEffect(() => {
    if (props.open) {
      // Pause inactivity timer when training video opens
      ActivityStore.pauseTimer()
      setModalDimensions()
      bind()
    } else {
      // Resume inactivity timer when training video closes
      ActivityStore.resumeTimer()
    }

    return () => {
      // Ensure timer resumes if component unmounts while open
      if (props.open) {
        ActivityStore.resumeTimer()
      }
      unbind()
    }
  }, [props.open, bind, unbind, setModalDimensions])

  const isOpen = !!(props?.open && props?.videoUrl)

  return (
    <MDBModal className='VideoPlayerModal' open={isOpen} tabIndex='-1' onClose={close}>
      <MDBModalDialog size='fluid'>
        <MDBModalContent>
          <MDBModalHeader color='indigo'>
            <MDBModalTitle>
              USABG Welcome
              <br />
              <span>{props?.videoTitle}</span>
            </MDBModalTitle>
            <MDBBtn type='button' className='btn-close' color='none' onClick={close}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            <div className='video-wrapper'>
              {props?.videoUrl ? (
                <div style={{ width: dimensions.width, height: dimensions.height }}>
                  <iframe
                    src={props?.videoUrl.replace(/(<([^>]+)>)/gi, '')}
                    frameBorder='0'
                    allow='autoplay; fullscreen; picture-in-picture'
                    allowFullScreen
                    title={`video-${props?.videoTitle}`}
                  ></iframe>
                </div>
              ) : (
                <></>
              )}
            </div>
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}

export default observer(VideoPlayerModal)
